import { gql } from "@apollo/client";

export const AcknowledgeIotAlert = gql`
    mutation AcknowledgeIotAlert($id: ID!, $input: AcknowledgeIotAlertInput!) {
        acknowledgeIotAlert(id: $id, input: $input) {
            id
        }
    }
`;
